import { createRoot } from 'react-dom/client'
import TagManager from 'react-gtm-module'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'react-oauth2-code-pkce'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { authConfig, routes } from './app'
import { HelmetProvider } from 'react-helmet-async'

const { env } = window
env.gtmId && TagManager.initialize({ gtmId: env.gtmId })
document.body.tabIndex = -1

const queryClient = new QueryClient()
const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider authConfig={authConfig}>
      <HelmetProvider>
        <RouterProvider router={createBrowserRouter(routes)} />
      </HelmetProvider>
    </AuthProvider>
  </QueryClientProvider>
)
